import type ApplicationData from "@/modules/ApplicationData";
import type ExperienceData from "@/modules/ExperienceData";
import type FavoritesData from "@/modules/FavoritesData";
import type * as pluginManager from "@/plugin/pluginManager";

export type { ExperienceState } from "@/types/state";

export const experienceDataStatus = {
  UNKNOWN: "UNKNOWN",
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
} as const;

export type ExperienceStatus =
  (typeof experienceDataStatus)[keyof typeof experienceDataStatus];

/** The orientation layout (orientationPortrait / orientationLandscape). */
export interface ExperienceTemplate {
  setShowControlBar(value: boolean): void;
  setShowPanel(value: boolean): void;
}

/** The live store model; plugins and store listeners receive this object. */
export interface ExperienceModel {
  experienceData: ExperienceData;
  favoritesData: FavoritesData;
  applicationData: ApplicationData;
  status: ExperienceStatus;
  template: ExperienceTemplate;
  error: unknown;
  plugin: typeof pluginManager;
}
